export default __webpack_public_path__ + "static/media/alamin_resume_web_developer (1).2b2ec5c7.pdf";